import { bindActionCreators } from 'redux';
import { WIX_CHAT, MEMBERS_AREA } from '@wix/app-definition-ids';
import { biVisitMemberProfile } from '../common/store/actions/bi-actions';
import { decorateActionsWithLogger } from './utils/monitoring';
import { requestLoginPromisified } from '../common/store/actions/request-login';
import { controllerActions } from './controller-actions';
export function initControllerActions({ wixCodeApi, store, sentry, logErrorsToConsole, }) {
    return {
        wcActions: decorateActionsWithLogger({
            ...bindActionCreators(controllerActions, store.dispatch),
            startPrivateChat: (uid) => wixCodeApi.site.getPublicAPI(WIX_CHAT).then((api) => api.startPrivateChat(uid)),
            navigateToMember: (memberId, memberSlug, resourceId) => {
                store.dispatch(biVisitMemberProfile({ memberId, resourceId }));
                wixCodeApi.site
                    .getPublicAPI(MEMBERS_AREA)
                    .then((api) => api.navigateToMember({ memberId, memberSlug }));
            },
            navigateToSection: (section) => wixCodeApi.site.getPublicAPI(MEMBERS_AREA).then((api) => api.navigateToSection(section)),
            requestLogout: () => {
                wixCodeApi.user.logout();
            },
        }, sentry, logErrorsToConsole),
        wcActionsPromisified: decorateActionsWithLogger(bindActionCreators({ requestLoginPromisified }, store.dispatch), sentry, logErrorsToConsole),
    };
}
//# sourceMappingURL=init-controller-actions.js.map